// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildMinified,
  BuildMinifiedFromJSON,
  BuildMinifiedToJSON,
  ProjectMini,
  ProjectMiniFromJSON,
  ProjectMiniToJSON,
  Upload,
  UploadFromJSON,
  UploadToJSON,
  User,
  UserFromJSON,
  UserToJSON,
} from "./";

/**
 *
 * @export
 * @interface TestPlanLog
 */
export interface TestPlanLog {
  /**
   * Type of entity
   * @type {string}
   * @memberof TestPlanLog
   */
  log: string;
  /**
   * Test plan ID
   * @type {number}
   * @memberof TestPlanLog
   */
  testPlan: number;
  /**
   * Test plan title
   * @type {string}
   * @memberof TestPlanLog
   */
  testPlanTitle?: string;
  /**
   * Test case title
   * @type {string}
   * @memberof TestPlanLog
   */
  testCaseTitle?: string;
  /**
   * Test plan configuration ID
   * @type {number}
   * @memberof TestPlanLog
   */
  testPlanConfiguration?: number;
  /**
   * Test plan test case ID
   * @type {number}
   * @memberof TestPlanLog
   */
  testPlanTestCase?: number;
  /**
   *
   * @type {Array<Upload>}
   * @memberof TestPlanLog
   */
  attachments?: Array<Upload>;
  /**
   *
   * @type {BuildMinified}
   * @memberof TestPlanLog
   */
  build?: BuildMinified;
  /**
   * How the result recorded by this entry was produced (TCV-6815). Set only on entries that record a result. Absent on entries written before this was tracked, which is why there is no \"unknown\" member - a missing value means it was never recorded, not that it was manual.
   * @type {string}
   * @memberof TestPlanLog
   */
  executionSource?: TestPlanLogExecutionSourceEnum;
  /**
   *
   * @type {ProjectMini}
   * @memberof TestPlanLog
   */
  project?: ProjectMini;
  /**
   * Activity Type
   * @type {string}
   * @memberof TestPlanLog
   */
  activityType: TestPlanLogActivityTypeEnum;
  /**
   *
   * @type {User}
   * @memberof TestPlanLog
   */
  user: User;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof TestPlanLog
   */
  createdAt?: string;
}

export function TestPlanLogFromJSON(json: any): TestPlanLog {
  return {
    log: json["log"],
    testPlan: json["test_plan"],
    testPlanTitle: !exists(json, "test_plan_title")
      ? undefined
      : json["test_plan_title"],
    testCaseTitle: !exists(json, "test_case_title")
      ? undefined
      : json["test_case_title"],
    testPlanConfiguration: !exists(json, "test_plan_configuration")
      ? undefined
      : json["test_plan_configuration"],
    testPlanTestCase: !exists(json, "test_plan_test_case")
      ? undefined
      : json["test_plan_test_case"],
    attachments: !exists(json, "attachments")
      ? undefined
      : (json["attachments"] as Array<any>).map(UploadFromJSON),
    build: !exists(json, "build")
      ? undefined
      : BuildMinifiedFromJSON(json["build"]),
    executionSource: !exists(json, "execution_source")
      ? undefined
      : json["execution_source"],
    project: !exists(json, "project")
      ? undefined
      : ProjectMiniFromJSON(json["project"]),
    activityType: json["activity_type"],
    user: UserFromJSON(json["user"]),
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
  };
}

export function TestPlanLogToJSON(value?: TestPlanLog): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    log: value.log,
    test_plan: value.testPlan,
    test_plan_title: value.testPlanTitle,
    test_case_title: value.testCaseTitle,
    test_plan_configuration: value.testPlanConfiguration,
    test_plan_test_case: value.testPlanTestCase,
    attachments:
      value.attachments === undefined
        ? undefined
        : (value.attachments as Array<any>).map(UploadToJSON),
    build: BuildMinifiedToJSON(value.build),
    execution_source: value.executionSource,
    project: ProjectMiniToJSON(value.project),
    activity_type: value.activityType,
    user: UserToJSON(value.user),
    created_at: value.createdAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum TestPlanLogExecutionSourceEnum {
  Manual = "manual",
  Ci = "ci",
  Api = "api",
  Agent = "agent",
  Import = "import",
}
/**
 * @export
 * @enum {string}
 */
export enum TestPlanLogActivityTypeEnum {
  Add = "add",
  Edit = "edit",
  Delete = "delete",
  Publish = "publish",
  Run = "run",
  FinishedRun = "finished_run",
  Comment = "comment",
  Unlink = "unlink",
}
